import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResponseViewProcessordersTable } from '../_models';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})
export class SearchTableViewProcessordersService {

  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(
    SelectCostumer: Number
    
  ): Observable<ResponseViewProcessordersTable[]> {
    
    const requestUrl = `${environment.apiUrl}/Shipping/PlaceOrderViewProcess`;
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario
    var Request = {};
    Request['customerId'] = SelectCostumer;
    return this._httpClient.post<ResponseViewProcessordersTable[]>(requestUrl, Request, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Methods': '*',
        Authorization: 'Bearer ' + json.token,
      }),
    });
  }
  getSearchOrderShipping(
    SelectCostumer: Number,
    status:Number
    
  ): Observable<ResponseViewProcessordersTable[]> {
    
    const requestUrl = `${environment.apiUrl}/Shipping/shippingOrderViewProcess?CustomerId=${SelectCostumer}&status=${status}`;
    var json = JSON.parse(localStorage.getItem('currentUser')); //json con datos de usuario
    var Request = {};
    Request['customerId'] = SelectCostumer;
    return this._httpClient.get<ResponseViewProcessordersTable[]>(requestUrl, {
      headers: new HttpHeaders({
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
        'Access-Control-Allow-Methods': '*',
        Authorization: 'Bearer ' + json.token,
      }),
    });
  }
}
